const dzStyles = theme => ({
    companyLogoDz: {
        border: "0 !important",
        background: "transparent !important",
        "& .dz-message": {
            margin: 0,
            // border: "0px !important",
            // borderRadius: "50% !important",
            // background: "#EEEEEE",
            // width: "150px",
            // height: "150px",
            // paddingTop: "122px !important",
            // position: "relative",
            // "& .camera": {
            //     position: "absolute",
            //     left: 0,
            //     right: 0,
            //     marginLeft: "auto",
            //     marginRight: "auto",
            //     top: "50%",
            //     WebkitTransform: "translateY(-50%)",
            //     MozTransform: "ranslateY(-50%)",
            //     MsTransform: "translateY(-50%)",
            //     OTransform: "translateY(-50%)",
            //     transform: "translateY(-50%)",
            //     maxHeight: "100%",
            //     maxWidth: "100%",
            // },
            // "& .red-plus": {
            //     position: "absolute",
            //     bottom: "-10px",
            //     right: "-10px",
            // },
            // "& .dz-message": {
            //     position: "absolute",
            // },
        },
        "& .dz-image-preview": {
            margin: "32px 0px",
            width: "122px",
            position: "relative",
            textAlign: "left",
            "& .dz-details": {
                "& .dz-thumbnail": {
                    borderRadius: "50% !important",
                    width: "122px",
                },
            },
            "& .dz-remove": {
                "& div": {
                    background: "#FF005C",
                    borderRadius: "50%",
                    cursor: "pointer",
                    color: "#FFFFFF",
                    position: "absolute",
                    right: "0px",
                    bottom: "15px",
                    width: "24px",
                    height: "24px",
                    "& *": {
                        verticalAlign: "bottom",
                    },
                },
            },
        },
    },
    companyBRDz: {
        border: "0 !important",
        background: "transparent !important",
        "& .dz-message": {
            margin: 0,
        },
        "& .dz-remove": {
            "& div": {
                background: "#FF005C",
                borderRadius: "50%",
                cursor: "pointer",
                color: "#FFFFFF",
                width: "24px",
                height: "24px",
                margin: "auto",
                "& *": {
                    verticalAlign: "bottom",
                },
            },
        },
    },
    documentDz: {
        border: "0 !important",
        background: "transparent !important",
        textAlign: "left !important",
        maxWidth: "inherit",
        "& .dz-message": {
            color: "#00BCD4",
            fontSize: "16px",
            fontWeight: "bold",
            border: "2px solid #EEEEEE",
            borderRadius: "5px",
            margin: "0px",
            marginBottom: "20px",
            padding: "8px 50px",
            textTransform: "uppercase",
            display: "inline-block !important",
            width: "max-content",
        },
        "& .dz-image-preview": {
            display: "flex",
            "& .dz-details": {
                whiteSpace: "pre-line",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxHeight: "48px",
                marginRight: "auto",
                marginBottom: "20px",
                "& span": {
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    verticalAlign: "top",
                    fontSize: "16px",
                    fontWeight: "normal",
                },
            },
            "& .dz-remove": {
                cursor: "pointer",
            },
        },
    },
    NewFactoryProfileDz: {
        display: "none",
    },
    companyPhotoDz: {
        border: "0 !important",
        background: "transparent !important",
        textAlign: "left !important",
        whiteSpace: "nowrap",
        overflowY: "auto",
        "& .dz-message": {
            margin: 0,
        },
        "& .dz-image-preview": {
            display: "inline-flex",
            width: "120px",
            marginBottom: "10px",
            marginRight: "5px",
            "& .dz-details": {
                width: "100%",
                "& .dz-thumbnail": {
                    display: "block",
                    margin: "auto",
                },
                "& .dz-file-info": {
                    background: "#000000",
                    color: "#FFFFFF",
                    padding: "0px 5px 2px",
                    "& .dz-file-name": {
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    },
                    "& .dz-remove": {
                        "& div": {
                            background: "#FF005C",
                            borderRadius: "50%",
                            cursor: "pointer",
                            color: "#FFFFFF",
                            width: "24px",
                            height: "24px",
                            margin: "auto",
                            "& *": {
                                verticalAlign: "bottom",
                            },
                        },
                    },
                },
            },
        },
    },
    productDetailDz: {
        border: "0 !important",
        background: "transparent !important",
        "& .dz-message": {
            color: "#00BCD4",
            fontSize: "16px",
            fontWeight: "bold",
            border: "2px solid #EEEEEE",
            borderRadius: "5px",
            margin: "0px",
            padding: "8px 0px",
            textTransform: "uppercase",
        },
        "& .dz-details": {
            whiteSpace: "pre-line",
            overflow: "hidden",
            textOverflow: "ellipsis",
            marginBottom: "5px",
            maxHeight: "48px",
        },
        "& .dz-remove": {
            "& div": {
                background: "#FF005C",
                borderRadius: "50%",
                cursor: "pointer",
                color: "#FFFFFF",
                width: "24px",
                height: "24px",
                margin: "auto",
                "& *": {
                    verticalAlign: "bottom",
                },
            },
        },
    },
    auditCertDz: {
        border: "0 !important",
        background: "transparent !important",
        "& .dz-message": {
            margin: 0,
        },
        "& .dz-details": {
            whiteSpace: "pre-line",
            overflow: "hidden",
            textOverflow: "ellipsis",
            marginBottom: "5px",
            maxHeight: "48px",
        },
        "& .dz-remove": {
            "& div": {
                background: "#FF005C",
                borderRadius: "50%",
                cursor: "pointer",
                color: "#FFFFFF",
                width: "24px",
                height: "24px",
                margin: "auto",
                "& *": {
                    verticalAlign: "bottom",
                },
            },
        },
    },
    companyProfileLogoDz: {
        border: "0 !important",
        background: "transparent !important",
        "& .dz-message": {
            border: "0px !important",
            borderRadius: "50% !important",
            background: "#EEEEEE",
            width: "200px",
            height: "200px",
            top: "-60px",
            paddingTop: "122px !important",
            position: "relative",
            "& .camera": {
                position: "absolute",
                left: 0,
                right: 0,
                marginLeft: "auto",
                marginRight: "auto",
                top: "50%",
                WebkitTransform: "translateY(-50%)",
                MozTransform: "ranslateY(-50%)",
                MsTransform: "translateY(-50%)",
                OTransform: "translateY(-50%)",
                transform: "translateY(-50%)",
                maxHeight: "100%",
                maxWidth: "100%",
            },
            "& .red-plus": {
                position: "absolute",
                bottom: "-10px",
                right: "-10px",
            },
            "& .dz-message": {
                position: "absolute",
            },
        },
        "& .dz-image-preview": {
            margin: "32px 0px",
            width: "122px",
            position: "relative",
            textAlign: "left",
            "& .dz-details": {
                "& .dz-thumbnail": {
                    borderRadius: "50% !important",
                    width: "122px",
                },
            },
            "& .dz-remove": {
                "& div": {
                    background: "#FF005C",
                    borderRadius: "50%",
                    cursor: "pointer",
                    color: "#FFFFFF",
                    position: "absolute",
                    right: "0px",
                    bottom: "15px",
                    width: "24px",
                    height: "24px",
                    "& *": {
                        verticalAlign: "bottom",
                    },
                },
            },
        },
    },

    emailAttachmentDz: {
        border: "0 !important",
        background: "transparent !important",
        "& .dz-message": {
            display: "block !important",
            float: "left",
            width: "130px",
            border: "2px dashed #C7C7C7",
            margin: `${theme.spacing(1)} 0px`,
            padding: "32px 0px",
            textTransform: "uppercase",
            "& .dz-message-text": {
                color: "#00BCD4",
            },
        },
        "& .dz-remove": {
            textAlign: "center",
            "& div": {
                background: "#FF005C",
                borderRadius: "50%",
                cursor: "pointer",
                color: "#FFFFFF",
                width: "24px",
                height: "24px",
                margin: "auto",
                "& *": {
                    verticalAlign: "bottom",
                },
            },
        },
    },
});

export default dzStyles;
